export default __webpack_public_path__ + "static/media/last1.3e475ef9.jpg";